export class Failure extends Error {
    constructor(code, payload) {
        super(code);
        this.code = code;
        this.payload = payload;
        Object.setPrototypeOf(this, Failure.prototype);
    }
}
//# sourceMappingURL=failure.js.map